/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ActionFormField {
    getFixupPrototypeFunction() { return ActionFormField.fixupPrototype; }

    static newInstance(model: Partial<ActionFormField>): ActionFormField {
        let obj = Object.assign(new ActionFormField(), model);
        ActionFormField.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ActionFormField>): ActionFormField {
        if (!model) return null;
        return ActionFormField.newInstance(<ActionFormField> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ActionFormField) {
        if (!obj) return;

        models.ActionFormField.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ActionFormField): boolean {
        Object.setPrototypeOf(obj, ActionFormField.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Field identifier
     */
    id: string;

    /**
     * Display label
     */
    label: string;

    /**
     * Field type: text, select, multi_select
     */
    type: string;

    /**
     * Whether field is required
     */
    required: boolean;

    /**
     * Default value
     */
    default: any;

    /**
     * Options for select fields
     */
    options: Array<any>;

    /**
     * Placeholder text
     */
    placeholder: string;

    /**
     * Section this field belongs to
     */
    section_id: string;

}
